import { render, staticRenderFns } from "./PoiSearch.vue?vue&type=template&id=474778a4"
import script from "./PoiSearch.vue?vue&type=script&lang=js"
export * from "./PoiSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports